/* eslint-disable import/prefer-default-export */

import { GET_TAGS, GET_TAGS_SUCCESS, GET_TAGS_FAIL, RESET_TAGS } from '../constants';
import { buildQuery } from '../helpers';
export function getTags() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page: 1,
    perPage: 50,
    sort: '-name',
    search: '',
    archived: false
  };
  var query = buildQuery(params);
  return {
    types: [GET_TAGS, GET_TAGS_SUCCESS, GET_TAGS_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/tags?".concat(query), {
        method: 'GET'
      });
    }
  };
}
export function reset() {
  return {
    type: RESET_TAGS
  };
}